import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomLanguagesModal } from "./CustomLanguagesModal";

import "./styles.scss";

const MAX_DISPLAYED_LANGUAGES = 2;

interface ICustomLanguagesSelectProps {
  languages: string[];
  changeLanguages: (languages: string[]) => void;
  disabled?: boolean;
}

export const CustomLanguagesSelect = (props: ICustomLanguagesSelectProps) => {
  const { t: _t } = useTranslation();
  const t = (key: string, args?: Record<string, string | number>) =>
    _t(`hookForm.languageSelect.customLanguagesSelect.${key}`, args);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { languages, changeLanguages, disabled } = props;

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const displayedLanguages = languages.slice(0, MAX_DISPLAYED_LANGUAGES);
  const remainingCount = languages.length - MAX_DISPLAYED_LANGUAGES;
  const hasMore = remainingCount > 0;

  const getLanguageName = (code: string) => _t(`common.language.${code}`, code);

  return (
    <>
      <div className={`custom-languages-select ${disabled ? "disabled" : ""}`}>
        <div className="custom-languages-select-list">
          {languages.length === 0 && (
            <div className="custom-languages-select-item not-language">
              {t("no_languages_selected")}
            </div>
          )}
          {displayedLanguages.map((code) => (
            <div key={code} className="custom-languages-select-item">
              {getLanguageName(code)}
            </div>
          ))}
          {hasMore && (
            <div
              className="custom-languages-select-item not-language"
              title={languages
                .slice(MAX_DISPLAYED_LANGUAGES)
                .map(getLanguageName)
                .join(", ")}
            >
              {t("show_more", { count: remainingCount })}
            </div>
          )}
          <button
            type="button"
            className="btn btn-border"
            onClick={handleOpenModal}
            disabled={disabled}
          >
            {languages.length > 0 ? t("edit") : t("add")}
          </button>
        </div>
      </div>
      {isModalOpen && (
        <CustomLanguagesModal
          languages={languages}
          changeLanguages={changeLanguages}
          handleClose={handleCloseModal}
        />
      )}
    </>
  );
};
